import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateBillingPortalSessionMutationVariables = Types.Exact<{
  returnUrl: Types.Scalars['String']['input'];
}>;


export type CreateBillingPortalSessionMutation = { __typename?: 'Mutation', createBillingPortalSession: { __typename?: 'StripeBillingPortalSessionPayload', portalUrl?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CreateMySubscriptionCheckoutSessionMutationVariables = Types.Exact<{
  frequency: Types.BillingFrequency;
}>;


export type CreateMySubscriptionCheckoutSessionMutation = { __typename?: 'Mutation', createMySubscriptionCheckoutSession: { __typename?: 'StripeCheckoutSessionPayload', sessionUrl?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateBillingPortalSessionDocument = new TypedDocumentString(`
    mutation CreateBillingPortalSession($returnUrl: String!) {
  createBillingPortalSession(returnUrl: $returnUrl) {
    portalUrl
    errors {
      code
      message
    }
  }
}
    `);
export const CreateMySubscriptionCheckoutSessionDocument = new TypedDocumentString(`
    mutation CreateMySubscriptionCheckoutSession($frequency: BillingFrequency!) {
  createMySubscriptionCheckoutSession(frequency: $frequency) {
    sessionUrl
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateBillingPortalSession: build.mutation<CreateBillingPortalSessionMutation, CreateBillingPortalSessionMutationVariables>({
      query: (variables) => ({ document: CreateBillingPortalSessionDocument, variables })
    }),
    CreateMySubscriptionCheckoutSession: build.mutation<CreateMySubscriptionCheckoutSessionMutation, CreateMySubscriptionCheckoutSessionMutationVariables>({
      query: (variables) => ({ document: CreateMySubscriptionCheckoutSessionDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateBillingPortalSessionMutation, useCreateMySubscriptionCheckoutSessionMutation } = injectedRtkApi;
